import React from 'react'
import PropTypes from 'prop-types'

import styles from './Spinner.css'

const propTypes = {
    caption: PropTypes.node,
}

class Spinner extends React.PureComponent {
    render() {
        const caption = this.props.caption ? (
            <div className={styles.caption}>{this.props.caption}</div>
        ) : null

        return(
            <div className={styles.base}>
                {caption}
                <div className={styles.spinner} />
            </div>
        )
    }
}


Spinner.propTypes = propTypes

export default Spinner



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Spinner/Spinner.jsx